import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./components/LoginPage";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminPage from "./pages/AdminPage";
import HomePage from "./pages/HomePage"; // 👈 create this simple page

function App() {
  return (
    <Router>
      <Routes>
        {/* 👇 Public home route */}
        <Route path="/" element={<HomePage />} />

        {/* 👇 Login route */}
        <Route path="/login" element={<LoginPage />} />

        {/* 👇 Protected admin route */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute allowedRoles={["ROLE_ADMIN"]}>
              <AdminPage />
            </ProtectedRoute>
          }
        />

        {/* 👇 Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
